import { Icon, IconProps } from "@chakra-ui/react"

const SyncIcon = ({
  fillColor = "black",
  ...props
}: { fillColor?: string } & IconProps) => (
  <Icon width='16px' height='16px' viewBox='0 0 16 16' fill='none' {...props}>
    <path
      d='M13.5838 8.92469V7.99344C13.5838 4.90813 11.0763 2.40625 7.98383 2.40625C7.14255 2.40522 6.31188 2.59395 5.55364 2.95841C4.79541 3.32286 4.12915 3.85365 3.60445 4.51125M2.40039 7.07375V8.005C2.40039 11.0938 4.90664 13.5938 8.00039 13.5938C8.83926 13.5925 9.6673 13.4042 10.4242 13.0424C11.181 12.6806 11.8476 12.1545 12.3754 11.5025'
      stroke={fillColor}
      strokeMiterlimit='10'
      strokeLinecap='square'
    />
    <path
      d='M1 8L2.375 6.625L3.8125 8M15 8L13.625 9.375L12.1875 8'
      stroke={fillColor}
      strokeMiterlimit='10'
      strokeLinecap='square'
    />
  </Icon>
)

export default SyncIcon
